<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span *ngIf="nameTypeId" jhiTranslate="crop-settings-manager.name-type.modal.edit.header"></span>
        <span *ngIf="!nameTypeId" jhiTranslate="crop-settings-manager.name-type.modal.create.header"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row">
            <label for="nameTypeCode" class="col-sm-3 col-form-label fw-bold" jhiTranslate="crop-settings-manager.name-type.code">Code</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" name="code" id="code" [(ngModel)]="nameType.code" #nameTypeCode="ngModel" jhi-forbiddenCharactersValidator [maxLength]="50" [required]="true"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="nameTypeName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="crop-settings-manager.name-type.name">Name</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" name="name" id="name" [(ngModel)]="nameType.name" #nameTypeName="ngModel" jhi-forbiddenCharactersValidator [maxLength]="50" [required]="true"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="nameTypeDescription" class="col-sm-3 col-form-label fw-bold" jhiTranslate="crop-settings-manager.name-type.description">Description</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" name="description" id="description" [(ngModel)]="nameType.description" #nameTypeDescription="ngModel" jhi-forbiddenCharactersValidator [maxLength]="255"/>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary" data-test="createNameTypeButton">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;
        <span *ngIf="nameTypeId" jhiTranslate="update"></span>
        <span *ngIf="!nameTypeId" jhiTranslate="create"></span>
    </button>
</div>

